import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import { useAuthStore } from '@/stores/auth'
import client_lookups from '@/assets/json/clientLookups.json'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const authStore = useAuthStore()
  const { applicationId } = authStore.user
  const { serviceTransactionId } = globalStore.startedService
  const {
    isCanceled = '',
    sponsoredUN = '',
    fileNumber = '',
    administrativeRegionId = '',
    withException = ''
  } = router.currentRoute.value.query
  formStore.extraMap = {
    ...formStore.extraMap,
    visaDuarationMsg: '',
    serviceTransactionId,
    administrativeRegionId,
    fileNumber,
    isCanceled: isCanceled != '0',
    withException: withException == 'true',
    hideSponsorInformation: false,
    isSponsorIdentityNumber: false
  }
  if (applicationId == 2) return
  if (!formStore.extraMap.isCanceled && sponsoredUN) {
    let res = await apiHelperService.get(`/api/individual/${sponsoredUN}/sponsored`)
    if (res) {
      const {
        resiDepartmentCode = '',
        resiVisaDepartmentCode = '',
        resiYear = '',
        resiVisaYear = '',
        resiServiceCode = '',
        resiVisaServiceCode = '',
        resiSequenceNumber = '',
        resiVisaSequenceNumber = '',
        fileNumber = ''
      } = res
      formStore.draft.request = {
        ...formStore.draft.request,
        ...res,
        fileDepartmentCode: resiDepartmentCode || resiVisaDepartmentCode,
        fileYear: resiYear || resiVisaYear,
        fileTypeCode: resiServiceCode || resiVisaServiceCode,
        fileSeqNo: resiSequenceNumber || resiVisaSequenceNumber,
        fileNumber: fileNumber || formStore.extraMap.fileNumber
      }
    }
  }
  if (formStore.extraMap.isCanceled) {
    let res = await apiHelperService.get(
      447 == serviceTransactionId
        ? `/api/individual/residency/${fileNumber}`
        : `/api/individual/visa/${fileNumber}`
    )
    if (res) {
      const {
        fileNumber = '',
        departmentCode = '',
        serviceYear = '',
        serviceCode = '',
        sequenceNumber = ''
      } = res
      formStore.draft.request = {
        ...formStore.draft.request,
        ...res,
        professionId: 3876,
        fileDepartmentCode: departmentCode,
        fileYear: serviceYear,
        fileTypeCode: serviceCode,
        fileSeqNo: sequenceNumber,
        fileNumber: fileNumber || formStore.extraMap.fileNumber
      }
    }
  }
}

const setDefaultVal = (res) => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const { applicationId } = authStore.user
  const {
    application: { residencyCancelled }
  } = client_lookups
  if (applicationId != residencyCancelled) {
    return
  }
  const {
    fileDepartmentCode,
    fileYear,
    fileCode,
    fileSequence,
    englishFullName,
    arabicFullName,
    nationalityId,
    professionId,
    dateOfBirth,
    sponsorTypeId,
    personFileTypeId
  } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    fileDepartmentCode,
    fileYear,
    fileTypeCode: fileCode,
    fileSeqNo: fileSequence,
    englishName: englishFullName,
    arabicName: arabicFullName,
    currentNationalityId: nationalityId,
    professionId,
    dateOfBirth,
    sponsorTypeId: sponsorTypeId || personFileTypeId
  }
}

const initInfo = async () => {
  const formStore = useFormStore()
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    formStore.draft.request.individualInfo = res
    setDefaultVal(res)
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use446Preload error: ', error)
  }
}
